import { Flex, useBreakpoint } from "@simplybusiness/mobius";
import { StyledSkeleton } from ".";
import { customBreakpoints } from "../../../constants/breakpoints";

export const CardSkeletonUK = () => {
  const { down } = useBreakpoint(customBreakpoints);
  const isMobileDevice = down("md");

  return (
    <li className="mobius-quote-card">
      {/* <Header /> */}
      <Flex
        className="mobius-quote-card__header --is-uk"
        flexDirection="column"
        gap="xxs"
      >
        <div className="mobius-quote-card__header-logo --is-uk">
          <StyledSkeleton height="40px" />
        </div>
      </Flex>
      {/* <Pricing /> */}
      <div className="mobius-quote-card__pricing --is-uk">
        <Flex justifyContent="space-between" gap="md">
          <div style={{ width: "50%", marginBottom: "6px" }}>
            <StyledSkeleton height="34px" />
          </div>
          {!isMobileDevice && (
            <div style={{ width: "50%" }}>
              <StyledSkeleton
                height="34px"
                className="mobius-quote-card__badges --is-uk"
              />
            </div>
          )}
        </Flex>
        <Flex style={{ marginBottom: "6px" }} flexDirection="column" gap="xs">
          <StyledSkeleton width="100%" />
          <StyledSkeleton width="100%" />
        </Flex>
        {isMobileDevice && (
          <StyledSkeleton
            className="mobius-quote-card__badges --is-uk"
            height="34px"
            width="50%"
          />
        )}
      </div>
      {/* <Coverage /> */}
      <div className="mobius-quote-card__coverage">
        <p className="mobius mobius-text --is-h3 mobius-quote-card__coverage-title">
          <StyledSkeleton />
        </p>
        {!isMobileDevice && (
          <Flex
            gap="sm"
            className="mobius-quote-card__coverage-items"
            flexDirection="column"
          >
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
            <StyledSkeleton />
          </Flex>
        )}
      </div>
      {/* <QuoteActions /> */}
      <Flex className="mobius-quote-actions-form">
        <Flex
          gap="sm"
          justifyContent="space-between"
          className="mobius-quote-actions"
        >
          <div className="mobius-quote-actions__button mobius-quote-actions__button--is-details">
            <StyledSkeleton height="40px" />
          </div>
          <div className="mobius-quote-actions__button mobius-quote-actions__button--is-select">
            <StyledSkeleton height="40px" />
          </div>
        </Flex>
      </Flex>
    </li>
  );
};
